import ThemedTile from './components/ThemedTile/ThemedTile.jsx';

const version = process.env.VERSION;

export { ThemedTile, version };

export default ThemedTile;
